import './UnderlineNav-78db938f.css';

var classes = {"MenuItemContent":"prc-UnderlineNav-MenuItemContent-k4WNL"};

export { classes as default };
